<template>
    <div class="tabs">
        <!--closable这里说明home是不能关闭的-->
        <el-row style="overflow: hidden;">
            <el-col :span="23" style="overflow: hidden;">
                <!-- <el-tag
                        :key="index"
                        size="mini"
                        v-for="(tag, index) in tags"
                        :closable="tag.name !== 'home'"
                        :disable-transitions="true"
                        @close="handleClose(tag, index)"
                        @click="changeMenu(tag)"
                        :effect="$route.path === tag.path ? 'dark' : 'plain'"
                    >
                        {{ tag.label }}
                    </el-tag> -->
                <el-tabs v-model="urname" @edit="handleTabsEdit" @tab-click="handleClick">
                    <el-tab-pane size="mini" :key="index" v-for="(tag, index) in tags" :label="tag.label"
                                 :name="tag.name" :closable="tag.name !== 'home'"></el-tab-pane>
                </el-tabs>
            </el-col>
            <el-col :span="1" style="position: fixed; height: 25px;line-height: 25px;right:0.5rem">
                <el-dropdown size="mini" type="primary" style="white-space: pre;">
					<span class="el-dropdown-link">
						{{ $t('getapi[7976]') }}
						<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item icon="el-icon-circle-close" @click.native="colose">{{ $t('getapi[7977]')
                            }}
                        </el-dropdown-item>
                        <el-dropdown-item icon="el-icon-close" @click.native="colose1">{{ $t('getapi[7978]') }}
                        </el-dropdown-item>
                        <el-dropdown-item icon="el-icon-close" @click.native="colose2">{{ $t('getapi[7979]') }}
                        </el-dropdown-item>
                        <el-dropdown-item
                                v-for="(tag, ind) in tags"
                                :divided="ind == 0"
                                :disabled="$route.path === tag.path ? true : false"
                                :key="ind"
                                @click.native="changeMenu(tag)"
                        >
                            {{ tag.label }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-dropdown size="mini" split-button type="primary">
                    {{ $t('basic.edit') }}
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item icon="el-icon-circle-close" @click.native="colose">{{ $t('basic.colseall') }}</el-dropdown-item>
                        <el-dropdown-item icon="el-icon-close" @click.native="colose1">{{ $t('basic.colse') }}</el-dropdown-item>
                        <el-dropdown-item icon="el-icon-close" @click.native="colose2">{{ $t('basic.colseother') }}</el-dropdown-item>
                        <el-dropdown-item v-for="(tag, ind) in tags" :divided="ind==0" :disabled="$route.path === tag.path ? true : false" :key="ind" @click.native="changeMenu(tag)">
                            {{ tag.label }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
                <!-- <el-dropdown trigger="click" size="mini" >
                    <span class="el-tag el-tag--small el-tag--dark">
                        {{ $t('basic.edit') }}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item icon="el-icon-circle-close" @click.native="colose">{{ $t('basic.colseall') }}</el-dropdown-item>
                        <el-dropdown-item icon="el-icon-close" @click.native="colose1">{{ $t('basic.colse') }}</el-dropdown-item>
                        <el-dropdown-item icon="el-icon-close" @click.native="colose2">{{ $t('basic.colseother') }}</el-dropdown-item>
                        <el-dropdown-item v-for="(tag, ind) in tags" :disabled="$route.path === tag.path ? true : false" :key="ind" @click.native="changeMenu(tag)">{{ tag.label }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex';
    import CommonAside from '@/components/CommonAside';
    import Common from '@/components/Common';
    export default {
        computed: {
            ...mapState({
                tags: state => state.tab.tabsList
            })
        },
        data() {
            return {
                urname: ''
            };
        },
        created() {
            let st = this.$store;
            this.urname = this.$route.name;
            //this.tags = sessionStorage.getItem('tabsList');
            let tabl = sessionStorage.getItem('tabsList');
        },

        watch: {
            $route: function (e) {
                this.urname = e.name;
            },
            '$i18n.locale': function () {
                mapState({
                    tags: state => state.tab.tabsList
                });
            }
        },
        methods: {
            ...mapMutations({
                close: 'closeTab',
                closeAll: 'closeAll',
                closeOther: 'closeOther'
            }),
            handleTabsEdit(targetName, action) {
                let that = this
                console.log(targetName, action);

                if (action === 'remove') {
                    let flag = false
                    let flag1 = false
                    let index
                    for(let i = 0;i<Common.modelcache.length;i++){
                        if(Common.modelcache[i].key == targetName){
                            flag = true
                            flag1 = Common.modelcache[i].value.checkDataChange()
                            index = i
                        }
                    }
                    if(flag){
                        if(flag1){
                            that.closeModel(targetName,index)
                        } else {
                            let tabs = this.tags;
                            tabs.forEach((tab, index) => {
                                if (tab.name === targetName) {
                                    this.handleClose(tab, index);
                                }
                            });
                        }
                    } else {
                        let tabs = this.tags;
                        tabs.forEach((tab, index) => {
                            if (tab.name === targetName) {
                                this.handleClose(tab, index);
                            }
                        });
                    }
                }
            },
            closeModel(targetName,index){
                let that = this
                that.$confirm(that.$t('getapi[3655]'), that.$t('getapi[194]'), {//'数据已发生改变，是否保存后关闭？'
                    confirmButtonText: that.$t('getapi[2052]'),
                    cancelButtonText: that.$t('getapi[2053]'),
                    type: 'warning'
                })
                    .then(() => {
                        Common.modelcache[index].value.save()
                    })
                    .catch(() => {
                        let tabs = this.tags;
                        tabs.forEach((tab, index) => {
                            if (tab.name === targetName) {
                                this.handleClose(tab, index);
                            }
                        });
                    });
            },
            handleClick(tab, event) {
                console.log(tab)
                let tabs = this.tags;
                if(tab.name.indexOf('4_') != -1){
                    this.$changeTab.$emit('changeTab', 4)
                }else if(tab.name.indexOf('5_') != -1) {
                    this.$changeTab.$emit('changeTab', 5)
                } else if(tab.name.indexOf('3_') != -1) {
                    this.$changeTab.$emit('changeTab', 3)
                } else if(tab.name.indexOf('2_') != -1){
                    this.$changeTab.$emit('changeTab', 2)
                } else {
                    /*CommonAside.methods.changeTabs(1)*/
                    this.$changeTab.$emit('changeTab', 1)
                }
                tabs.forEach((tabss, index) => {
                    if (tabss.name === tab.name) {
                        this.changeMenu(tabss);
                    }
                });
            },
            //关闭标签
            handleClose(tag, index) {
                console.log(tag);
                console.log(this.$route);
                let length = this.tags.length - 1;
                //vuex调方法的另一种写法
                this.close(tag);
                // 如果关闭的标签不是当前路由的话，就不跳转
                if (tag.name !== this.$route.name) {
                    return;
                }
                // 关闭的标签是最右边的话，往左边跳转一个
                if (index === length) {
                    this.$router.push({name: this.tags[index - 1].name});
                    this.$store.commit("selectMenu", this.tags[index - 1]);
                } else {
                    // 否则往右边跳转
                    this.$router.push({name: this.tags[index].name});
                    this.$store.commit("selectMenu", this.tags[index]);
                }
            },
            //选择标签跳转路由
            changeMenu(item) {
                this.$router.push({path: item.path});
                this.$store.commit('selectMenu', item);
            },
            colose(command) {
                let that = this;
                that.closeAll();
                that.$router.push({
                    name: 'home'
                });
                // that.tags.forEach(function(it, ind) {
                // 	if(ind>0){
                // 		console.log(it.path);
                // 		if (it.path != '/') {
                // 			that.close(it);
                // 		}
                // 	}

                // });
            },
            colose1(command) {
                let that = this;
                that.tags.forEach(function (it, ind) {
                    if (it.name != 'home') {
                        if (it.name == that.$route.name) {
                            that.close(it);
                            that.$router.push({name: that.tags[ind - 1].name});
                        }
                    }
                });
            },
            colose2(command) {
                let that = this;
                that.closeOther(that.$route);
                that.$router.push({name: that.$route.name});
                // that.tags.forEach(function(it, ind) {
                // 	if (it.name != that.$route.name && it.name != 'home') {
                // 		that.close(it);
                // 	}
                // });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .tabs {
        overflow-y: hidden;
        background: #fff;
        display: inline-block;
        line-height: 50px;
        min-height: 50px;
        margin: 0 20px;
        padding: 0 20px;
        .el-tag {
            margin-right: 10px;
            cursor: pointer;
        }
        .el-breadcrumb__inner {
            color: #fff;
        }
    }

    .el-dropdown-menu {
        height: 50%;
        overflow-y: auto;
    }
</style>
